import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { UserProfileService } from '../../../services/profile/user-profile.service';
import { PlanService } from '../../../services/plan/plan.service';
import { JwtTokenService } from '../../../services/auth/jwt-token.service';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-allergies-dialog',
  templateUrl: './allergies-dialog.component.html',
  styleUrls: ['./allergies-dialog.component.scss'],
  animations: [
        trigger(
          'enterAnimation', [
            transition(':enter', [
              style({transform: 'translateX(-100%)', opacity: 0}),
              animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
            ])
          ]
        ),
        trigger('fade_obj', [ 
            transition('void => *', [
                style({ opacity: 0 }), 
                animate(500, style({opacity: 1}))
            ]) 
        ])
    ],
})
export class AllergiesDialogComponent {

  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;
  allergies: any[] = [];
  

  @Input() preSelectedAllergies: any[] = [];
  @Input() visible: boolean = false;
  @Input() dialog: boolean = true;
  @Input() showTitle: boolean = true;
  @Input() title: string = 'Do you have any allergies?';
  @Input() subtitle: string = 'We will show only meals safe for you.';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() nextAction = new EventEmitter<any[]>();
  @Output() hide = new EventEmitter<void>();

  constructor(
    private userProfileService: UserProfileService,
    private jwtService: JwtTokenService,
    private planService: PlanService,
    private sizedetection: ResizeDetectionService,
    private spinner: NgxSpinnerService
  ){}

  ngOnInit(){
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
        this.isDesktop = data.isDesktop;
        this.isTablet = data.isTablet;
        this.isMobile = data.isMobile;

    });

    this.spinner.show('allergies-spinner');
    this.planService.getAllergies().subscribe({
      next: (data:any) => {
        //console.log(data.body);
        this.allergies = data.body;
        this.allergies.forEach((allergy:any) => {
            allergy.selected = false;
            allergy.is_hover = false;
            switch (allergy.key_name) {
                case 'gluten': allergy.icon = 'assets/images/allergies/Gluten.png'; break;
                case 'wheat': allergy.icon = 'assets/images/allergies/Wheat.png'; break;
                case 'rye': allergy.icon = 'assets/images/allergies/Gluten.png'; break;
                case 'barley': allergy.icon = 'assets/images/allergies/Wheat.png'; break;
                case 'oats': allergy.icon = 'assets/images/allergies/Wheat.png'; break;
                case 'spelt': allergy.icon = 'assets/images/allergies/Gluten.png'; break;
                case 'crustaceans': allergy.icon = 'assets/images/allergies/Crab.png'; break;
                case 'eggs': allergy.icon = 'assets/images/allergies/Eggs.png'; break;
                case 'fish': allergy.icon = 'assets/images/allergies/Fish.png'; break;
                case 'peanuts': allergy.icon = 'assets/images/allergies/Peanut.png'; break;
                case 'soybeans': allergy.icon = 'assets/images/allergies/Soy Bean.png'; break;
                case 'milk': allergy.icon = 'assets/images/allergies/Milk.png'; break;
                case 'nuts': allergy.icon = 'assets/images/allergies/Nuts.png'; break;
                case 'celery': allergy.icon = 'assets/images/allergies/Celery.png'; break;
                case 'mustard': allergy.icon = 'assets/images/allergies/Mustard.png'; break;
                case 'sesame': allergy.icon = 'assets/images/allergies/Sesame.png'; break;
                case 'sulphites': allergy.icon = 'assets/images/allergies/Sulfur Dioxide & Sulphites.png'; break;
                case 'lupin': allergy.icon = 'assets/images/allergies/Lupine.png'; break;
                case 'molluscs': allergy.icon = 'assets/images/allergies/Abalone.png'; break;
            }
        });

        if(this.preSelectedAllergies){
          this.preSelectedAllergies.forEach((allergyId:number) => {
              this.allergies.filter((x:any)=>x.id == allergyId)[0].selected = true;
          });
        } else { // this else should be moved out to the caller as this component should be agnostic
          this.jwtService.getIsLogin().subscribe(() => {
              this.userProfileService.getUserProfile().subscribe(userProfile => {
                  userProfile.allergies.forEach((allergy:any) => {
                      this.allergies.filter((x:any)=>x.id == allergy.id)[0].selected = true;
                  });
              });
          });
        }
        this.spinner.hide('allergies-spinner');
    },
    error: (error) => {
      console.log(error);
      this.spinner.hide('allergies-spinner');
    }
  });
}

  mouseEnterAllergy(allergy: any) {
    allergy.is_hover = true;
  }

  mouseLeaveAllergy(allergy: any) {
    allergy.is_hover = false;
  }

  onDialogHide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.hide.emit();
  }

  saveAllergies() {
    this.nextAction.emit(this.allergies);
    this.onDialogHide();
  }
}